import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import AppNav from '../AppNav'
import Router from 'next/router'
import NProgress from 'nprogress'

Router.onRouteChangeStart = () => {
  NProgress.start()
}
Router.onRouteChangeComplete = () => {
  NProgress.done()
}

Router.onRouteChangeError = () => {
  NProgress.done()
}

const StyledHeader = styled.div``

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'MierA-Regular';
    src: url('/static/fonts/MierA/MierA-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'MierA-Bold';
    src: url('/static/fonts/MierA/MierA-Bold.otf') format('opentype');
  }

  @font-face {
    font-family: 'MierA-Light';
    src: url('/static/fonts/MierA/MierA-Light.otf') format('opentype');
  }
  body {
    font-family: 'MierA-Regular';
    text-align: center;
    height: 100vh;
  }

  ul {
    list-style: none;
  }

`

class Header extends React.Component {
  render() {
    return (
      <StyledHeader>
        <GlobalStyle />
        <AppNav />
      </StyledHeader>
    )
  }
}

export default Header
